var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 246.1 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M77.4 200c92.9 0 143.7-76.9 143.7-143.6 0-2.2-.1-4.4-.1-6.5 9.9-7.2 18.4-16 25.2-26.1-9.2 4.1-19 6.8-29 8 10.6-6.3 18.4-16.3 22.2-28-9.9 5.9-20.8 10.1-32.1 12.3-19.1-20.3-51.1-21.3-71.4-2.2-13.1 12.3-18.7 30.7-14.6 48.2A144 144 0 0 1 17.1 9.3c-13.4 23-6.5 52.5 15.7 67.4-8-.2-15.9-2.4-22.9-6.3v.7c0 24 17 44.7 40.5 49.5-4.3 1.2-8.8 1.8-13.3 1.8-3.2 0-6.4-.3-9.5-.9 6.6 20.6 25.6 34.7 47.2 35.1-17.9 14-40 21.6-62.8 21.6-4 0-8-.2-12-.7C23.1 192.1 49.9 200 77.4 200"
  })));
};
export default SvgTwitter;